import { render, staticRenderFns } from "./CreateChatPage.vue?vue&type=template&id=0e3231bc&scoped=true&"
import script from "./CreateChatPage.vue?vue&type=script&lang=js&"
export * from "./CreateChatPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateChatPage.vue?vue&type=style&index=0&id=0e3231bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3231bc",
  null
  
)

export default component.exports